import { render, staticRenderFns } from "./PaymentCheckPage.vue?vue&type=template&id=ef4b1c92&"
import script from "./PaymentCheckPage.vue?vue&type=script&lang=js&"
export * from "./PaymentCheckPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports